import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=13008922&scoped=true&"
import script from "./Observations.vue?vue&type=script&lang=js&"
export * from "./Observations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13008922",
  null
  
)

export default component.exports